module.exports = __webpack_public_path__ + "static/img/logoLogin.be9e7ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoLogin.png
// module id = 773
// module chunks = 0